<template>
    <div>

    <v-btn depressed small light class="mr-2" @click="priceImportDialogOpen()"><v-icon small class="mr-2">mdi-file-import-outline</v-icon>Импорт</v-btn>

    <dialog-editor :item.sync="isOpen" name="Настройка импорта" width="640" footer-hide content-padding-remove disableOverlayClick>
        <template v-slot:afterTitle>
            <tooltip right>              
            <v-icon class="ml-2">mdi-help-circle-outline</v-icon>
            <template v-slot:content>
                <p class="caption mb-3">Условия для папок:</p> 
                <ol class="mb-3">
                    <li>Папкой считается элемент, у которого в ряду нет больше заполненных столбцов</li>
                    <li>Уровень папок определяется их смещением относительно друг друга по столбцам:
                        <ul>
                        <li>Папка 1
                            <ul>
                            <li>Подпапка 1.1</li>
                            <li>Подпапка 1.2</li>
                            </ul>
                        </li>
                        </ul>
                    </li>
                </ol>
                <p class="caption mb-3">Названия столбцов для автоопределения:</p> 
                <ul class="pb-5">
                    <li>Название услуги</li>
                    <li>Код услуги</li>
                    <li>Код в клинике</li>
                    <li>Цена, руб</li>
                    <li>Цена выполнения</li>
                    <li>Цена расходных материалов</li>
                    <li>ДМС</li>
                    <li>ОМС</li>
                    <li>Длительность</li>
                    <li>Комментарий</li>
                    <li>Филиал</li>
                    <li>Лимит строк</li>
                    <li>Раздел</li>
                    <li>Код профиля</li>
                    <li>Название профиля</li>
                    <li>Контейнер</li>
                    <li>Биоматериал</li>
                    <li>Формат результата</li>
                </ul>
            </template>
            </tooltip>
        </template>

        <template v-slot:actions>
            <v-menu
              v-model="priceSampleMenu"
              :close-on-content-click="true"
              :nudge-width="200"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn depressed small light class="mr-2" v-bind="attrs" v-on="on"><v-icon small class="mr-2">mdi-microsoft-excel</v-icon>Скачать образец</v-btn>
              </template>
              
              <v-card>
                <v-list dense>
                  <v-list-item
                      href="/panel/priceExample/simple_price_import.csv"
                      download
                    >
                      <v-list-item-content>
                        <v-list-item-title>Простой</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                      href="/panel/priceExample/complex_price_import.csv"
                      download
                    >
                      <v-list-item-content>
                        <v-list-item-title>Комплекс (Профили)</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                </v-list>
              </v-card>
            </v-menu>
        </template>
        <div class="px-5 py-5">
            <div class="caption">Раздел для импорта:</div>
            <v-breadcrumbs v-if="serviceCatOpenData" class="pa-0 mb-5">
            <div v-for="(bread, i) in breadItems" :key="i">
                <v-breadcrumbs-item :class="'caption font-weight-medium '+(i<breadItems.length-1 ? 'grey--text clickable' : '')">

                <tooltip v-if="bread.comBranch!==null" right>              
                    <v-avatar class="mr-2" :color="bread.comBranch.color" size="10" style="margin-top:-1px"/> 
                    <template v-slot:content>
                    {{bread.comBranch.name}}
                    </template>
                </tooltip>

                <chip v-if="bread.isProgram===true" color="green" small dark class="mr-2">Программа</chip>
                <span>{{bread.text}}</span>
                </v-breadcrumbs-item>
                <v-breadcrumbs-divider v-if="i<breadItems.length-1">/</v-breadcrumbs-divider>
            </div>
            </v-breadcrumbs>
            <v-breadcrumbs v-else class="pa-0 mb-5">
            <span>корневой</span>
            </v-breadcrumbs>

            <autocomplete-single  class="mb-5" name="Тип загружаемого прайс листа" :items="importTypes" :select.sync="selectedType" :readonly="true"/>
   
            <v-simple-table class="pa-0" dense>
                <template v-slot:default>
                <thead>
                <tr>
                    <th>Поле</th>
                    <th>Колонка</th>
                    <th>Активно</th>
                </tr>
                </thead>
                <tbody>
                    
                <tr
                    v-for="(key, index) in Object.keys(formData)"
                    :key="'priceImport_'+index"        
                    :class="formData[key].enabled!==undefined&&!formData[key].enabled&&'isInactive'"       
                > 
                    <template v-if="
                    (formData.file.value!==null||formData[key].type ==='file')
                    &&formData[key].type!=='hidden'">
                    <td class="py-1">
                        {{ formData[key].title }}
                    </td>
                    <td class="py-1">
                        <v-file-input v-if="formData[key].type==='file'" label="Файл" prepend-icon="" v-model="formData[key].value" :rules="formFieldRules.required" outlined dense hide-details="auto" />

                        <v-text-field v-if="formData[key].type==='text'"  class="mb-0" :label="formData[key].title" v-model="formData[key].value" outlined dense hide-details="auto" :rules="formData[key].required ? formFieldRules.required : []" clearable/>
                            
                        <autocomplete-single v-if="formData[key].type==='tableCol'" class="mb-0" :name="formData[key].title" :items="priceHeaders"  @update:select="(v)=>updateFieldVal(key,v)" :select="priceHeaders.filter(i=>i.value===formData[key].value)[0]" :required="!formData[key].required&&undefined" :key="'Field_'+index"/>

                        <com-branch-autocomplete-single v-if="formData[key].type==='comBranch'" class="mb-0" @update:select="(v)=>updateFieldVal(key,v)" />
                    </td>
                    <td class="py-1">

                        <v-checkbox
                        v-if="formData[key].enabled!==undefined"
                        @change="(v)=>showHideField(key,v)"
                        color="primary"
                        hide-details
                        class="pa-0 mt-0"
                        ></v-checkbox>
                    </td>
                    </template>
                </tr>
                </tbody>
                </template>
            </v-simple-table>

            <v-btn v-if="formData?.file.value" class="mt-3" depressed block small color="primary" @click="priceImport()">
                <v-icon class="mr-2" small>mdi-file-import-outline</v-icon> Импорт
            </v-btn>
                    
        </div>
    </dialog-editor>
    </div>
</template>

<script>
import Api from "@/Api";
import {FormFieldRules} from "@/plugins/formFieldRules";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import ComBranchAutocompleteSingle from "@/componentsV2/custom/ComBranchAutocompleteSingle.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";


export default {
    components: {
        ComBranchAutocompleteSingle,
        DialogEditor,
        AutocompleteSingle,
        Tooltip,
    },
    props: ['serviceCatOpenData','breadItems'],
    data: () => ({
        priceSampleMenu: false,
        formFieldRules: FormFieldRules,
        baseformData: {
            file: {title:'Файл',value:null, type:'file', required:true},
            nameColumn: {title:'Название услуги', type:'tableCol', value:null, required:true},
            codeColumn: {title:'Код услуги', type:'tableCol', value:null, enabled:false, required:false},
            isidColumn: {title:'Код в клинике', type:'tableCol', value:null, enabled:false, required:false},
            priceColumn: {title:'Цена, руб', value:null, type:'tableCol', enabled:false, required:false},
            priceExecColumn: {title:'Цена выполнения', value:null, type:'tableCol', enabled:false, required:false},
            priceExpendColumn: {title:'Цена расходных материалов', value:null, type:'tableCol', enabled:false, required:false},
            dmsColumn: {title:'ДМС', value:null, type:'tableCol', enabled:false, required:false},
            omsColumn: {title:'ОМС', value:null, type:'tableCol', enabled:false, required:false}, 
            durationColumn: {title:'Длительность', type:'tableCol', value:null, enabled:false, required:false},
            commentColumn: {title:'Комментарий', type:'tableCol', value:null, enabled:false, required:false},
            comBranchId: {title:'Филиал', value:null, type:'comBranch', enabled:false, required:false},
            limit: {title:'Лимит строк', value:5000, type:'text', enabled:false, required:false},
            targetId: {title:'Раздел', type:'hidden', value:null}
        },
        complexFormData:{
            profileCodeColumn: {title:'Код профиля', type:'tableCol', value:null, required:true},
            profileNameColumn: {title:'Наименование профиля', type:'tableCol', value:null, required:true},
            serviceCodeColumn: {title:'Код услуги', type:'tableCol', value:null, enabled:false, required:false},
            serviceNameColum: {title:'Название услуги', type:'tableCol', value:null, enabled:false, required:false},
            containerColumn: {title:'Контейнер', type:'tableCol', value:null, enabled:false, required:false},
            biomaterialColumn: {title:'Биоматериал', type:'tableCol', value:null, enabled:false, required:false},
            formatColumn: {title:'Формат результата', type:'tableCol', value:null, enabled:false, required:false},
        },
        formData: null,
        isOpen: false,
        importTypes: [
            {name:'Простой', id:'simple'},
            {name:'Комплекс', id:'complex'}
        ],
        selectedType: {name:'Простой', id:'simple'},
        priceHeaders:[],
    }),
    watch: {
        'formData.file.value'(file){
            if (file)
                this.loadPriceImportHeaders()
        },
        selectedType(v){

            if(v.id==='simple') {
                this.formData = this.baseformData;
            }
            else {//если комплекс убираем nameColumn, вместо него profileNameColumn
                this.formData = { ...this.formData, ...this.complexFormData };
                delete this.formData.nameColumn;
                delete this.formData.commentColumn
                delete this.formData.limit
                 
                this.formData.limit = {title:'Лимит строк', value:5000, type:'text', enabled:false, required:false};
            }

            this.compareFields()
        }
    },
    methods: {
        compareFields() {
            Object.keys(this.formData).forEach(key => {
                const field = this.formData[key];
                const header = this.priceHeaders.find(
                    h => h.name.trim().toLowerCase() === field?.title?.trim()?.toLowerCase()
                );
                if (header) {
                    field.value = header.value;
                }
            });
        },
        showHideField(key,v){
            this.formData[key].enabled = v;
        },
        updateFieldVal(key,v) {
            console.log(key);
            this.formData[key].value = v?.id!==undefined ? v.id : v?.value!==undefined ? v.value : null;
        },
        priceImportDialogOpen(){
            this.isOpen=true;
            
            if (!this.formData)
                this.formData = this.baseformData;

            if (this.serviceCatOpenData) 
                this.formData.targetId.value = this.serviceCatOpenData.id
            else 
                this.formData.targetId.value = null;
        },
        validateFormData(formData) {
            return !Object.values(formData).some(field => {
                if (field.required) {
                    return field.value === null || field.value === undefined || field.value === '';
                }
                return false;
            });
        },
        priceImport(){
            if (this.validateFormData(this.formData)){
                let formData = {};

                for (const key in this.formData) {
                if(this.formData[key]?.enabled===true||this.formData[key]?.enabled===undefined)
                    formData[key] = this.formData[key].value;
                }

                Api.service.service.priceImport(formData, ()=>{
                    this.isOpen = null;
                    console.log('раздел',this.serviceCatOpenData ? this.serviceCatOpenData.id : null);
                    this.$emit('reload',this.serviceCatOpenData ? this.serviceCatOpenData.id : null);
                }, (e)=>{
                    console.error(e);
                });
            }
        },
        loadPriceImportHeaders() {
            let formData = {
                file:this.formData.file.value
            }

            Api.service.service.priceImportHeaders(formData, (response)=>{
                
                if (response.data.length>0) {         
                    this.priceHeaders = response.data.map((item, index) => ({
                        name: item,
                        value: index
                    }));
                    this.compareFields()
                }
            }, (e)=>{
                console.error(e);
            });
        }
    },
};
</script>